import React from "react";
import { Link } from "react-router-dom";
import { LOOKBOOK_TILES } from "@/lib/constants";
import { useApiList } from "@/lib/useContentBlocks";

export default function Lookbook() {
  const looks = useApiList("/lookbook", []);
  const display = looks.length > 0
    ? looks
    : LOOKBOOK_TILES.map((t) => ({ title: t.title, cover_image: t.image, products: [] }));

  return (
    <main className="sq-container py-12" data-testid="lookbook-page">
      <div className="sq-eyebrow">Editorial</div>
      <h1 className="font-display text-5xl md:text-6xl mt-2">Trending Lookbook</h1>
      <p className="text-[#4B5563] mt-3 max-w-2xl">Stories of cloth, fit and city. Browse our seasonal editorials, then shop the look.</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mt-10">
        {display.map((t, i) => {
          const to = t.products?.[0] ? `/product/${t.products[0].id}` : "/fabrics";
          return (
            <Link key={t.id || i} to={to} data-testid={`lookbook-tile-${i}`} className="group">
              <div className="relative aspect-[3/4] overflow-hidden bg-black">
                <img src={t.cover_image} alt={t.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              </div>
              <div className="mt-3">
                <div className="sq-eyebrow">Look {String(i + 1).padStart(2, "0")}</div>
                <div className="font-display text-xl mt-1">{t.title}</div>
                {t.season && <div className="text-xs text-[#4B5563] mt-1">{t.season}</div>}
              </div>
            </Link>
          );
        })}
      </div>
    </main>
  );
}
